var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.containerStyle)},[_c('router-view',{key:_vm.$route.fullPath,attrs:{"tenantTeamPermissions":_vm.tenantTeamPermissions},on:{"updated-tenant-team-permissions":_vm.fetchTenantTeamPermissions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }